module.exports = __webpack_public_path__ + "assets-cabinet/img/arrow-right.f7e8c904.svg";